import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {LeadsActions} from '../store';
import {LeadsSelectors} from '../store/selectors';

@Injectable()
export class LeadsLoadedGuard implements CanActivate {

  constructor(private store$: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.readLeadsDone().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  readLeadsDone(): Observable<boolean> {
    return this.store$.pipe(
      select(LeadsSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store$.dispatch(LeadsActions.ReadLeads({page: 1}));
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
